import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../lib/api';

/** The app's query client: what is retried, and what happens to a server action while the browser is offline. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      // Only network failures are worth retrying: not_found / forbidden / invalid answers do not change.
      queries: { staleTime: 30_000, retry: (count, err) => count < 2 && (!(err instanceof ApiError) || err.code === 'network') },
      // Offline, a server action (save a version, invite, rename…) fails at once and says so, instead of waiting
      // unseen and running whenever the connection comes back (P12a): the person decides again.
      mutations: { networkMode: 'always' },
    },
  });
}
